import Axios from 'axios';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import Moment from 'moment';
import Chart from 'chart.js';
import { flash } from './core/helpers';
import Event from './core/Event';
import tailwind from '../../../tailwind';

/**
 * Init Global Event Bus.
 */
window.Event = new Event();

/**
 * Init Moment.
 */
window.moment = Moment;
window.moment.locale('fr');

/**
 * Init flash notifications.
 */
window.flash = flash;

/**
 * Init Axios.
 */
window.axios = Axios;
const token = document.head.querySelector('meta[name="csrf-token"]');
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Init Pusher.
 */
window.Pusher = Pusher;

/**
 * Init Echo.
 */
window.Echo = new Echo({
  broadcaster: 'pusher',
  key: process.env.MIX_PUSHER_APP_KEY,
  cluster: process.env.MIX_PUSHER_APP_CLUSTER,
});

/**
 * Init Chart.js
 */
Chart.defaults.global.defaultFontColor = tailwind.colors['gray-dark'];
Chart.defaults.global.defaultFontFamily = tailwind.fonts.sans;
Chart.defaults.global.defaultFontSize = 16;
Chart.defaults.global.title.fontColor = tailwind.colors['gray-darker'];
Chart.defaults.global.title.fontSize = 20;
Chart.defaults.global.title.position = 'top';
Chart.defaults.global.legend.position = 'bottom';
